import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { GALLERY } from "@/data/site";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <SEO title="Gallery of Completed Projects" description="Browse a gallery of completed custom cushion cover projects by Tanonshop — living rooms, campers, benches, patios and more." />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-14 lg:pt-28">
        <Reveal>
          <Eyebrow>Completed projects</Eyebrow>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.03] max-w-3xl">
            Twenty years of finished work.
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-teal-anchor/70 leading-relaxed font-light">
            A small selection of covers we've crafted for homes, campers and everything between.
            Each was measured, cut and sewn to fit its space exactly.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 lg:pb-32">
        <div className="grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[240px]">
          {GALLERY.map((g, i) => (
            <Reveal key={g.id} delay={(i % 4) * 0.06} className={`group relative overflow-hidden ${g.span} row-span-1`}>
              <img src={g.image} alt={g.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 flex items-end bg-gradient-to-t from-teal-anchor/70 via-teal-anchor/0 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <span className="p-5 text-sm font-semibold uppercase tracking-[0.15em] text-paper">{g.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-paper-soft py-20 text-center">
        <div className="mx-auto max-w-2xl px-5">
          <h2 className="font-serif text-3xl lg:text-4xl tracking-tight">Picture your project here.</h2>
          <Link to="/custom-order" className="mt-8 inline-flex items-center gap-2 rounded-sm bg-teal-primary px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-paper transition-all duration-200 hover:bg-teal-hover hover:-translate-y-px">
            Request a Custom Quote <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
